import { Link } from 'react-router-dom'
import {
  RiScissorsFill, RiMapPinLine, RiPhoneLine,
  RiMailLine, RiInstagramLine, RiFacebookCircleLine,
  RiWhatsappLine, RiYoutubeLine,
} from 'react-icons/ri'

const services = ['Hair Coloring', 'Haircuts', 'Bridal Makeup', 'Facials', 'Nail Art', 'Wellness']
const links = [
  { to: '/about',     label: 'About Us' },
  { to: '/our-team',  label: 'Our Team' },
  { to: '/pricing',   label: 'Pricing' },
  { to: '/gallery',   label: 'Gallery' },
  { to: '/blog',      label: 'Blog' },
  { to: '/faq',       label: 'FAQs' },
  { to: '/careers',   label: 'Careers' },
  { to: '/contact',   label: 'Contact' },
]

export default function Footer() {
  return (
    <footer className="bg-salon-dark text-salon-cream/70">
      {/* CTA band */}
      <div className="bg-salon-primary">
        <div className="container-salon py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="font-display text-white text-2xl font-bold">Ready for your transformation?</p>
            <p className="text-white/70 font-body mt-1">Book your appointment today and experience luxury beauty care.</p>
          </div>
          <Link to="/book"
            className="inline-flex items-center gap-2 bg-white text-salon-primary
                       font-semibold font-body px-8 py-3 rounded-full hover:shadow-lg
                       hover:-translate-y-0.5 transition-all duration-200 shrink-0">
            <RiScissorsFill /> Book Appointment
          </Link>
        </div>
      </div>

      {/* Main footer */}
      <div className="container-salon py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Brand */}
        <div className="lg:col-span-1">
          <Link to="/" className="inline-block mb-4" aria-label="Salon Vora — Home">
            <img src="/brand/logo.jpg" alt="Salon Vora" width="220" height="80" className="h-14 w-auto rounded-md object-contain" />
          </Link>
          <p className="text-sm leading-relaxed mb-5">
            Luxury hair & beauty studio where expertise meets artistry. Every visit is a unique experience crafted just for you.
          </p>
          <div className="flex items-center gap-3">
            {[
              { icon: RiInstagramLine, href: '#' },
              { icon: RiFacebookCircleLine, href: '#' },
              { icon: RiWhatsappLine, href: '#' },
              { icon: RiYoutubeLine, href: '#' },
            ].map(({ icon: Icon, href }) => (
              <a key={href} href={href}
                className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center
                           text-salon-cream/70 hover:text-white hover:bg-salon-primary
                           transition-all duration-200">
                <Icon className="text-lg" />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <p className="font-semibold text-white font-body mb-4">Services</p>
          <ul className="space-y-2">
            {services.map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm hover:text-salon-secondary transition-colors">{s}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick links */}
        <div>
          <p className="font-semibold text-white font-body mb-4">Quick Links</p>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm hover:text-salon-secondary transition-colors">{l.label}</Link>
              </li>
            ))}
            <li><Link to="/book" className="text-sm text-salon-secondary hover:text-salon-secondary-light transition-colors font-semibold">Book Appointment →</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="font-semibold text-white font-body mb-4">Contact</p>
          <ul className="space-y-3">
            <li className="flex items-start gap-3 text-sm">
              <RiMapPinLine className="text-salon-secondary mt-0.5 shrink-0 text-base" />
              123 Beauty Lane, Anna Nagar, Chennai – 600040
            </li>
            <li className="flex items-center gap-3 text-sm">
              <RiPhoneLine className="text-salon-secondary shrink-0 text-base" />
              <a href="tel:+919876543210" className="hover:text-white transition-colors">+91 98765 43210</a>
            </li>
            <li className="flex items-center gap-3 text-sm">
              <RiMailLine className="text-salon-secondary shrink-0 text-base" />
              <a href="mailto:hello@salonvora.com" className="hover:text-white transition-colors">hello@salonvora.com</a>
            </li>
          </ul>
          <div className="mt-5 p-4 rounded-xl bg-white/5 border border-white/10">
            <p className="text-xs font-semibold text-white mb-1 font-body">Working Hours</p>
            <p className="text-xs">Mon – Sat: 9:00 AM – 8:00 PM</p>
            <p className="text-xs">Sunday: 10:00 AM – 6:00 PM</p>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div className="container-salon py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-salon-cream/40">
          <p>© {new Date().getFullYear()} Salon Vora. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="hover:text-salon-cream/70 transition-colors">Privacy Policy</Link>
            <Link to="/terms"          className="hover:text-salon-cream/70 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
